var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62 47.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fizet\\xE9s"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.98,
    y: 17.83,
    width: 43.02,
    height: 28.21,
    rx: 3.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.44,39.83l-1.26.46a3.48,3.48,0,0,1-4.5-2L1.22,18.38a3.5,3.5,0,0,1,2.05-4.5L37,1.23a3.49,3.49,0,0,1,4.51,2l4.31,11.47"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.98,
    y1: 23.85,
    x2: 61,
    y2: 23.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.98,
    y1: 29.4,
    x2: 61,
    y2: 29.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.49,
    y1: 34.94,
    x2: 30.59,
    y2: 34.94
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentWhite);
export default __webpack_public_path__ + "static/media/paymentWhite.8e17e3ccc5341981be7a42aba8b39a1c.svg";
export { ForwardRef as ReactComponent };